module.exports = __webpack_public_path__ + "img/debi.7e9fc181.jpg";